export default "__VITE_ASSET__BZsS58uT__"